import { modifyQueryString } from '@dimjs/utils';
import { core } from '../core/index.js';
/**
 * 关闭所有页面，打开到应用内的某个页面
 */
export type FabricWebviewRelaunchOptions<T = number> = {
  /**
   * 需要跳转的应用内页面路径，路径后可以带参数。
   * 参数与路径之间使用?分隔，参数键与参数值用=相连，不同参数用&分隔；如 'path?key=value&key2=value2'
   */
  url: string;
  /**
   * 是否保留加载webview的动画加载器, true: 保持动画不关闭,手动关闭; false: 资源加载完毕后自动关闭
   * @default false
   */
  keepIndicator?: boolean;
  /**
   * 不透明度
   * @default 0.5
   */
  overlayOpacity?: number;
  /**
   * 点击透明遮罩是否关闭当前webview
   * @default false
   */
  overlayClickClose?: boolean;
  /**
   * 全屏webview还是半屏webview
   * Note: 半屏webview不支持自定义, 大小有native 写死, `half`模式只支持iOS(单独启一个容器栈, 而不是一个webview, android 暂不支持.)
   */
  screen?: 'full' | 'half' | T;
  /**
   * 动画方向从下往上top, 动画方向从右往左left, 从左往右只支持全屏, 从上往下支持全屏+半屏+自定义高度
   */
  direction?: 'top' | 'left';
};

export type FabricWebviewRelaunchApi = (
  options: FabricWebviewRelaunchOptions
) => void;
/**
 * 关闭所有页面，打开到应用内的某个页面, 保留当前tabbar, 停留的页面如果有.
 */
export const reLaunch: FabricWebviewRelaunchApi = (
  options: FabricWebviewRelaunchOptions
) => {
  const newUrl =
    options.keepIndicator === true
      ? modifyQueryString(options.url, {
          ntv_indicator: '',
        })
      : options.url;

  core.call<'fabric_webview.reLaunch', FabricWebviewRelaunchOptions<string>>(
    'fabric_webview.reLaunch',
    {
      ...options,
      url: newUrl,
      screen:
        typeof options.screen !== 'undefined'
          ? String(options.screen)
          : undefined,
    }
  );
};
